import * as React from 'react';
import { Component } from 'react';
import { Field, focus, Form, getFormValues, reduxForm } from 'redux-form';
import { __, dateFrom } from '../../core/utils';
import styles from '../../styles/forms/substages/EditSubstageToolbarForm.scss';
import Select from '../../components/Select';
import Tooltip from '../../components/Tooltip';
import TaskStatusIcon from '../../assets/images/task-status-15x15.svg';
import classNames from 'classnames';
import moment from 'moment';
import DateIcon from '../../assets/images/date-15x15.svg';
import connect from 'react-redux/es/connect/connect';
import { enableAutosave } from '../../redux/actions/general/autosave';
import * as _ from 'lodash';
import ArrowDownSmallIcon from '../../assets/images/arrow-down-small-15x15.svg';
import RangeSlider from '../../components/Slider';
import autobind from 'autobind-decorator';
import Dropdown from '../../components/Dropdown';
import Cleave from 'cleave.js/dist/cleave-react-node';
import ButtonGroup from '../../components/ButtonGroup';
import Button from '../../components/Button';
import { hideDropdown } from '../../redux/actions/general/dropdown';
import ClockIcon from '../../assets/images/clock-regular-full.svg';
import CalendarIcon from '../../assets/images/calender-svgrepo-com.svg';
import ProgressIcon from '../../assets/images/task-progress-icon.svg';
import TableNA from '../../components/TableNA';

const formatVarianceHours = (minutes) => {
  const hours = Math.abs(minutes) / 60;

  return `${Number(hours.toFixed(2))} h`;
};

const formatPerformanceDelta = (difference) => {
  if (difference > 0) {
    return `- ${Math.abs(difference)} D`;
  }

  if (difference < 0) {
    return `+ ${Math.abs(difference)} D`;
  }

  return '0 D';
};

@reduxForm({
  form: 'stages.edit_substage_toolbar',
  enableReinitialize: true,
})
@connect(
  (state) => ({
    dropdown: state.general.dropdown.shown,
    user_id: state.auth.id,
    values: getFormValues('stages.edit_substage_toolbar')(state),
  }),
  (dispatch) => ({
    focus: (field) => {
      dispatch(focus('stages.edit_substage_toolbar', field));
    },
  })
)
class EditSubstageToolbarForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      progress_percentage: null,
      planned_time: null,
    };
  }

  UNSAFE_componentWillReceiveProps() {
    enableAutosave(this.props.form);

    this.setState({
      progress_percentage: this.props.data.progress_percentage,
      planned_time: this.props.data?.time_log?.planned_time,
    });
  }

  @autobind
  updateProgress(value) {
    this.props.change('progress_percentage', value);

    setTimeout(() => this.props.submit(), 10);
  }

  @autobind
  updatePlannedTime(value) {
    this.props.change('time_log.planned_time', value);

    setTimeout(() => this.props.submit(), 10);
  }

  updateProgressDebounced = _.debounce(
    (values) => this.setState({ progress_percentage: values }),
    600
  );

  updatePlannedTimeDebounced = _.debounce(
    (values) => this.setState({ planned_time: values }),
    600
  );

  render() {
    const { data, user_id, values } = this.props;
    const { is_editor, is_reviewer } = data;
    const { progress_percentage } = this.state;
    const is_assignee = _.includes(_.map(data.assignee, 'id'), user_id);
    const status = _.get(values, 'status');
    // const disabled =
    //   !is_editor || _.includes(['closed', 'canceled'], data.status);
    const disabled = _.includes(['closed', 'canceled'], data?.status);
    const timeLog = data?.time_log;
    const schedule = data?.schedule;
    const isFinalSubstageStatus = _.includes(
      ['finished', 'closed', 'canceled'],
      data?.status
    );

    const isAllDay = data?.date?.allDay === 1;
    const dateFormat = isAllDay ? 'DD.MM.YYYY' : 'DD.MM.YYYY HH:mm';

    const startMoment = data?.date?.start
      ? moment.utc(data?.date?.start).local()
      : null;

    const endMoment = data?.date?.end
      ? moment.utc(data?.date?.end).local()
      : null;
    const finishedAtMoment = data?.finished_at
      ? moment.utc(data?.finished_at).local()
      : null;

    // const start_date = data?.date?.start
    //   ? moment.utc(data?.date.start).local().format('DD.MM.YYYY HH:mm')
    //   : '.';
    // const end_date = data?.date?.end
    //   ? moment.utc(data?.date.end).local().format('DD.MM.YYYY HH:mm')
    //   : '.';

    const start_date = data?.date?.start
      ? moment.utc(data?.date?.start).local().format(dateFormat)
      : '.';

    const end_date = data?.date?.end
      ? moment.utc(data?.date?.end).local().format(dateFormat)
      : '.';

    const isOverLimitTimeLog = timeLog?.logged_percent > 100;
    const isOverLimitSchedule = schedule?.elapsed_percent > 100;
    const plannedTimeMinutes = Number(timeLog?.planned_time_minutes || 0);
    const hasLoggedTimeValue =
      timeLog?.logged_time_minutes || timeLog?.logged_time_minutes === 0;
    const loggedTimeMinutes = Number(timeLog?.logged_time_minutes || 0);
    const actualTimeDifference = plannedTimeMinutes - loggedTimeMinutes;
    const actualTimeDifferenceColor =
      actualTimeDifference > 0
        ? styles.green
        : actualTimeDifference < 0
        ? styles.red
        : styles.blue;
    const actualTimeDifferenceDisplayColor = isFinalSubstageStatus
      ? actualTimeDifferenceColor
      : actualTimeDifference < 0
      ? styles.red
      : styles.gray;
    const actualTimeDifferenceLabel = hasLoggedTimeValue
      ? isFinalSubstageStatus
        ? actualTimeDifference > 0
          ? `${formatVarianceHours(actualTimeDifference)} ${__(
              'tasks.flyout.toolbar.performance.under'
            )}`
          : actualTimeDifference < 0
          ? `${formatVarianceHours(actualTimeDifference)} ${__(
              'tasks.flyout.toolbar.performance.over'
            )}`
          : __('tasks.flyout.toolbar.performance.equal')
        : actualTimeDifference >= 0
        ? `${formatVarianceHours(actualTimeDifference)} ${__(
            'tasks.flyout.toolbar.performance.remaining'
          )}`
        : `${formatVarianceHours(actualTimeDifference)} ${__(
            'tasks.flyout.toolbar.performance.over'
          )}`
      : null;
    const comparisonMoment = isFinalSubstageStatus ? finishedAtMoment : moment();
    const finishedDateDifference =
      endMoment && comparisonMoment
        ? endMoment
            .clone()
            .startOf('day')
            .diff(comparisonMoment.clone().startOf('day'), 'days')
        : 0;
    const finishedDateDifferenceColor =
      finishedDateDifference > 0
        ? styles.green
        : finishedDateDifference < 0
        ? styles.red
        : styles.blue;
    const finishedDateDifferenceDisplayColor = isFinalSubstageStatus
      ? finishedDateDifferenceColor
      : finishedDateDifference < 0
      ? styles.red
      : styles.gray;
    const finishedDateDifferenceLabel = isFinalSubstageStatus
      ? data?.finished_at
        ? finishedDateDifference > 0
          ? `${Math.abs(finishedDateDifference)} d ${__(
              'tasks.flyout.toolbar.performance.early'
            )}`
          : finishedDateDifference < 0
          ? `${Math.abs(finishedDateDifference)} d ${__(
              'tasks.flyout.toolbar.performance.late'
            )}`
          : __('tasks.flyout.toolbar.performance.on_time')
        : null
      : endMoment
      ? finishedDateDifference >= 0
        ? `${Math.abs(finishedDateDifference)} d ${__(
            'tasks.flyout.toolbar.performance.remaining'
          )}`
        : `${Math.abs(finishedDateDifference)} d ${__(
            'tasks.flyout.toolbar.performance.late'
          )}`
      : null;
    const hasPerformanceSummary = !!finishedDateDifferenceLabel;
    const performanceSummaryLabel = hasPerformanceSummary
      ? formatPerformanceDelta(finishedDateDifference)
      : __('substages.tooltip.performance');
    const performanceSummaryColor = hasPerformanceSummary
      ? finishedDateDifferenceDisplayColor
      : styles.gray;

    const statuses = [
      {
        value: 'not-started',
        label: __('substages.status.not-started'),
        color: '#9C27B0',
        disabled: !_.includes(['started'], status),
      },
      {
        value: 'started',
        label: __('substages.status.started'),
        color: '#5777FC',
        disabled: !_.includes(['not-started', 'reopened'], status),
      },
      {
        value: 'finished',
        label: __('substages.status.finished'),
        color: '#ADD42B',
        disabled: !_.includes(['not-started', 'started'], status),
      },
      {
        value: 'closed',
        label: __('substages.status.closed'),
        color: '#009688',
        disabled: !_.includes(['not-started', 'started', 'finished'], status),
      },
      {
        value: 'reopened',
        label: __('substages.status.reopened'),
        color: '#303F9F',
        disabled: !_.includes(['finished', 'closed', 'canceled'], status),
      },
      {
        value: 'canceled',
        label: __('substages.status.canceled'),
        color: '#CCCDD1',
        disabled: !_.includes(
          ['not-started', 'started', 'finished', 'reopened'],
          status
        ),
      },
    ];

    const getStatusColor = (status) => {
      switch (status) {
        case 'not-started':
          return '#9C27B0';
        case 'started':
          return '#5777FC';
        case 'finished':
          return '#ADD42B';
        case 'closed':
          return '#009688';
        case 'reopened':
          return '#303F9F';
        case 'canceled':
          return '#CCCDD1';
        default:
          return 'gray';
      }
    };

    return (
      <Form onSubmit={this.props.handleSubmit} className={styles.wrapper}>
        <Dropdown
          top={35}
          readOnly={!schedule}
          leftStyled
          wrapperClassName={styles.dropdownWrapper}
          name={'Schedule'}
          header={
            <div className={styles.dropdownHeader}>
              {__('substages.flyout.toolbar.schedule')}
            </div>
          }
          content={
            <div className={styles.dropdownContent}>
              <div className={styles.plannedTitle}>
                {__('substages.flyout.toolbar.planned')}
              </div>
              <div className={styles.oneRow}>
                <div className={styles.item}>
                  <div className={styles.itemTitle}>
                    {__('substages.flyout.toolbar.schedule.start_date')}
                  </div>
                  <div className={styles.itemValue}>
                    {startMoment ? (
                      <div className={styles.dateTimeColumn}>
                        <div>{startMoment.format('DD.MM.YYYY')}</div>

                        {!isAllDay && (
                          <div className={styles.timeBelow}>
                            {startMoment.format('HH:mm')}
                          </div>
                        )}
                      </div>
                    ) : (
                      '.'
                    )}
                  </div>
                </div>
                <div className={classNames(styles.item, styles.secondItem)}>
                  <div className={styles.itemTitle}>
                    {__('substages.flyout.toolbar.schedule.end_date')}
                  </div>
                  <div className={styles.itemValue}>
                    {endMoment ? (
                      <div className={styles.dateTimeColumn}>
                        <div>{endMoment.format('DD.MM.YYYY')}</div>

                        {!isAllDay && (
                          <div className={styles.timeBelow}>
                            {endMoment.format('HH:mm')}
                          </div>
                        )}
                      </div>
                    ) : (
                      '.'
                    )}
                  </div>
                </div>
              </div>
              <div
                className={classNames(styles.plannedTitle, styles.actualTitle)}
              >
                {__('substages.flyout.toolbar.actual')}
              </div>
              <div
                className={classNames(
                  styles.oneRow
                  // isOverLimitSchedule && styles.overLimit
                )}
              >
                <div className={styles.item}>
                  <div className={styles.itemTitle}>
                    {__('substages.flyout.toolbar.schedule.elapsed')}
                  </div>
                  <div
                    className={classNames(
                      styles.itemValue,
                      schedule?.schedule_text_color &&
                        styles[schedule?.schedule_text_color]
                    )}
                  >
                    {schedule?.total_elapsed_time}{' '}
                    <div className={styles.itemValuePercentage}>
                      &nbsp;
                      {schedule?.elapsed_percent} %
                    </div>
                  </div>
                </div>
                <div className={classNames(styles.item, styles.secondItem)}>
                  <div className={styles.itemTitle}>
                    {schedule?.schedule_label}
                  </div>
                  <div
                    className={classNames(
                      styles.itemValue,
                      schedule?.schedule_text_color &&
                        styles[schedule?.schedule_text_color]
                    )}
                  >
                    {schedule?.remaining_time}
                    <div className={styles.itemValuePercentage}>
                      &nbsp;
                      {schedule?.remaining_percent} %
                    </div>
                  </div>
                </div>
              </div>
              <div className={classNames(styles.flex, styles.percentageBox)}>
                <div className={styles.percentageTitle}>
                  {__('substages.flyout.toolbar.schedule.progress')}
                </div>
                <div
                  className={classNames(styles.slider, styles.sliderSchedule)}
                >
                  <RangeSlider
                    value={schedule?.elapsed_percent}
                    disabled
                    color={schedule?.schedule_bar_color}
                  />
                  <div className={styles.sliderLabels}>
                    <span>0</span>
                    <span>100</span>
                  </div>
                </div>
              </div>
            </div>
          }
        >
          <Tooltip text={__('substages.tooltip.icon.schedule')}>
            <div className={styles.timeLogAndSchedulePercentage}>
              <CalendarIcon />
              {schedule?.elapsed_percent != null && (
                <span className={styles.number}>
                  {schedule.elapsed_percent}%
                </span>
              )}
              {!schedule && <TableNA />}
              {/* <span style={{ fontSize: '15px', marginBottom: '2px' }}>
                {timeLog?.logged_percent}
              </span>
              <span style={{ fontSize: '12px' }}>{'%'}</span> */}
              <div className={styles.rightCorner}>
                {/* <span
                  className={styles.dot}
                  style={{
                    background: getStatusColor(data?.status),
                    border: `${getStatusColor(data?.status)} 1px solid`,
                  }}
                /> */}
                <ArrowDownSmallIcon className={styles.dropdownArrow} />
              </div>
            </div>
          </Tooltip>
        </Dropdown>
        <Dropdown
          top={35}
          leftStyled
          wrapperClassName={styles.dropdownWrapper}
          name={'Time Log'}
          header={
            <div className={styles.dropdownHeader}>
              {/* <ClockIcon
                style={{ height: '18px', width: '18px', marginRight: '5px' }}
              /> */}
              {__('substages.flyout.toolbar.timelog')}
            </div>
          }
          content={
            <div className={styles.dropdownContent}>
              <div className={styles.plannedTitle}>
                {__('substages.flyout.toolbar.planned')}
              </div>
              <div className={styles.oneRow}>
                <div className={styles.item}>
                  <div className={styles.itemTitle}>
                    {__('substages.flyout.toolbar.estimate')}
                  </div>
                  <Cleave
                    className={styles.input}
                    maxLength={15}
                    type='text'
                    value={this.state.planned_time}
                    onChange={(e) =>
                      this.updatePlannedTimeDebounced(e.currentTarget.value)
                    }
                    disabled={disabled}
                  />
                </div>
                <div className={classNames(styles.item, styles.secondItem)}>
                  <div className={styles.itemTitle}>
                    {__('substages.flyout.toolbar.subtasks')}
                    {}
                    <span className={styles.variationLabel}>
                      {'(' + __('substages.flyout.toolbar.variation') + ')'}
                    </span>
                  </div>

                  {timeLog?.child_estimations_total &&
                  timeLog?.child_estimations_variance ? (
                    <div
                      className={classNames(
                        styles.itemValue,
                        // timeLog?.child_estimations_variance?.includes('+')
                        //   ? styles.redItem
                        //   : styles.blueItem
                        timeLog?.time_log_text_color &&
                          styles[timeLog.time_log_text_color]
                      )}
                    >
                      {timeLog?.child_estimations_total}
                      <div className={styles.itemValuePercentage}>
                        ({timeLog?.child_estimations_variance})
                      </div>
                    </div>
                  ) : (
                    <TableNA />
                  )}
                </div>
              </div>
              <div
                className={classNames(styles.plannedTitle, styles.actualTitle)}
              >
                {__('substages.flyout.toolbar.actual')}
              </div>
              <div
                className={classNames(
                  styles.oneRow
                  // isOverLimitTimeLog && styles.overLimit
                )}
              >
                <div className={styles.item}>
                  <div className={styles.itemTitle}>
                    {__('substages.flyout.toolbar.logged')}
                  </div>
                  <div
                    className={classNames(
                      styles.itemValue,
                      timeLog?.time_log_text_color &&
                        styles[timeLog.time_log_text_color]
                    )}
                  >
                    {timeLog?.logged_time}{' '}
                    <div
                      className={classNames(
                        styles.itemValuePercentage,
                        timeLog?.time_log_text_color &&
                          styles[timeLog.time_log_text_color]
                      )}
                    >
                      &nbsp;
                      {timeLog?.logged_percent} %
                    </div>
                  </div>
                </div>

                {/* <span
                    className={styles.dot}
                    style={{
                      background: getStatusColor(data?.status),
                      border: `${getStatusColor(data?.status)} 1px solid`,
                    }}
                  /> */}
                <div className={classNames(styles.item, styles.secondItem)}>
                  <div className={styles.itemTitle}>
                    {timeLog?.time_log_label}
                  </div>
                  <div
                    className={classNames(
                      styles.itemValue,
                      timeLog?.time_log_text_color &&
                        styles[timeLog.time_log_text_color]
                    )}
                  >
                    {isOverLimitTimeLog
                      ? `-${timeLog?.late_time}`
                      : timeLog?.remaining_time}
                    <div
                      className={classNames(
                        styles.itemValuePercentage,
                        timeLog?.time_log_text_color &&
                          styles[timeLog.time_log_text_color]
                      )}
                    >
                      &nbsp;
                      {isOverLimitTimeLog
                        ? timeLog?.late_percent
                        : timeLog?.remaining_percent}{' '}
                      %
                    </div>
                  </div>
                </div>
              </div>
              <div className={classNames(styles.flex, styles.percentageBox)}>
                <div className={styles.percentageTitle}>
                  {__('substages.flyout.toolbar.timelog.progress')}
                </div>
                <div className={styles.slider}>
                  <RangeSlider
                    value={timeLog?.logged_percent}
                    disabled
                    color={timeLog?.time_log_color}
                  />
                  <div className={styles.sliderLabels}>
                    <span>0</span>
                    <span>100</span>
                  </div>
                </div>
              </div>

              <div className={styles.saveFooter}>
                {!disabled && (
                  <ButtonGroup right>
                    <Button
                      lightBlue
                      medium
                      middleText={__('button.done')}
                      onClick={() => {
                        this.updatePlannedTime(this.state.planned_time);

                        hideDropdown();
                      }}
                    />
                  </ButtonGroup>
                )}
              </div>
            </div>
          }
        >
          <Tooltip text={__('substages.tooltip.icon.timelog')}>
            <div className={styles.timeLogAndSchedulePercentage}>
              <ClockIcon />
              <span className={styles.number}>
                {timeLog?.logged_percent + '%'}
              </span>
              {/* <span style={{ fontSize: '15px', marginBottom: '2px' }}>
                {timeLog?.logged_percent}
              </span>
              <span style={{ fontSize: '12px' }}>{'%'}</span> */}
              <div className={styles.rightCorner}>
                {/* <span
                  className={styles.dot}
                  style={{
                    background: getStatusColor(data?.status),
                    border: `${getStatusColor(data?.status)} 1px solid`,
                  }}
                /> */}
                <ArrowDownSmallIcon className={styles.dropdownArrow} />
              </div>
            </div>
          </Tooltip>
        </Dropdown>
        <Field
          name='status'
          //   disabled={
          //    !(
          //      is_editor ||
          //      (is_reviewer &&
          //        is_assignee &&
          //        _.includes(['not-started', 'started', 'reopened'], status))
          //    )
          //   }
          component={Select}
          label={__('Status')}
          options={statuses}
          noSort
          dropdown
          top={34}
          left={-40}
          icon={<TaskStatusIcon className={styles.taskStatus} />}
          wrapper={(handleOpen, activeItem) => (
            <Tooltip text={__('substages.tooltip.icon.status')}>
              <div
                //className={classNames(
                //  styles.dropdown,
                //  !(
                //  is_editor ||
                //  (is_reviewer &&
                //     is_assignee &&
                //     _.includes(
                //       ['not-started', 'started', 'reopened'],
                //       status
                //     ))
                //  ) && styles.disabled
                //)}
                className={styles.dropdown}
                style={{ background: activeItem.color }}
                onClick={handleOpen}
              >
                <TaskStatusIcon className={styles.taskStatus} />
                <div className={styles.button}>
                  {activeItem.label}
                  <ArrowDownSmallIcon />
                </div>
              </div>
            </Tooltip>
          )}
        />
        {/* PROGRESS */}
        <Dropdown
          top={35}
          leftStyled
          wrapperClassName={styles.dropdownWrapperPercentage}
          name={'Progress'}
          header={
            <div className={styles.dropdownHeader}>
              {__('substages.flyout.toolbar.progress.progress')}
            </div>
          }
          content={
            <div className={styles.dropdownContent}>
              <div className={styles.percentageBox}>
                {!disabled && (
                  <div className={styles.percentageTitle}>
                    {__('substages.flyout.toolbar.finished')}
                  </div>
                )}
                {data?.status === 'closed' && (
                  <div className={styles.percentageTitle}>
                    {__('substages.flyout.toolbar.closed')}
                  </div>
                )}
                {data?.status === 'canceled' && (
                  <div className={styles.percentageTitle}>
                    {__('substages.flyout.toolbar.canceled')}
                  </div>
                )}
                {!disabled && (
                  <div
                    className={classNames(styles.f1, styles.inputPercentageBox)}
                  >
                    <Cleave
                      className={classNames(
                        styles.input,
                        styles.inputPercentage
                      )}
                      options={{
                        numericOnly: true,
                      }}
                      maxLength={3}
                      type='text'
                      value={progress_percentage}
                      onChange={(e) =>
                        this.updateProgressDebounced(e.currentTarget.value)
                      }
                      disabled={!values.time_log.progress_enabled} // progress is sometimes disabled for stages, it is calculated as tasks sum
                    />
                    <div className={styles.percentage}> %</div>
                  </div>
                )}
                {disabled && <div className={styles.disabledWhiteSpace} />}
                {/* --  -- -- */}
                <div className={styles.slider}>
                  <RangeSlider
                    value={progress_percentage}
                    onChange={(value) =>
                      this.setState({ progress_percentage: value })
                    }
                    // disabled={disabled}
                    disabled={!values.time_log.progress_enabled} // progress is sometimes disabled for substages, it is calculated as tasks sum
                    color={disabled && 'gray'}
                  />
                  <div className={styles.sliderLabels}>
                    <span>0</span>
                    <span>100</span>
                  </div>
                </div>
              </div>
              <div className={styles.saveFooter}>
                {!disabled && (
                  <ButtonGroup right>
                    <Button
                      lightGray
                      medium
                      middleText={__('button.cancel')}
                      onClick={hideDropdown}
                    />
                    <Button
                      lightBlue
                      medium
                      middleText={__('button.done')}
                      onClick={() => {
                        this.updateProgress(this.state.progress_percentage);

                        hideDropdown();
                      }}
                    />
                  </ButtonGroup>
                )}
              </div>
            </div>
          }
        >
          <Tooltip text={__('substages.tooltip.icon.progress')}>
            <div
              className={styles.progressPercentage}
              style={{ backgroundColor: getStatusColor(data?.status) }}
            >
              <ProgressIcon />
              <span className={styles.number}>
                {data?.progress_percentage + '%'}
              </span>

              <div className={styles.rightCorner}>
                {/* <span
                  className={styles.dot}
                  style={{
                    background: getStatusColor(data?.status),
                    border: `${getStatusColor(data?.status)} 1px solid`,
                  }}
                /> */}
                <ArrowDownSmallIcon className={styles.dropdownArrow} />
              </div>
            </div>
          </Tooltip>
        </Dropdown>
        {/* PERFORMANCE */}
        <Dropdown
          top={35}
          right={0}
          wrapperClassName={styles.dropdownWrapper}
          name={'Performance'}
          header={
            <div className={styles.dropdownHeader}>
              {__('substages.flyout.toolbar.performance')}
            </div>
          }
          content={
            <div className={styles.dropdownContent}>
              <div className={styles.plannedTitle}>
                {__('substages.flyout.toolbar.performance.planned_title')}
              </div>
              <div className={styles.oneRow}>
                <div className={styles.item}>
                  <div className={styles.itemTitle}>
                    {__('substages.flyout.toolbar.performance.end_date')}
                  </div>
                  <div className={styles.itemValue}>
                    {startMoment ? (
                      <div className={styles.dateTimeColumn}>
                        <div>{endMoment.format('DD.MM.YYYY')}</div>

                        {!isAllDay && (
                          <div className={styles.timeBelow}>
                            {endMoment.format('HH:mm')}
                          </div>
                        )}
                      </div>
                    ) : (
                      '.'
                    )}
                  </div>
                </div>
                <div className={classNames(styles.item, styles.secondItem)}>
                  <div className={styles.itemTitle}>
                    {__('substages.flyout.toolbar.performance.estimate')}
                  </div>
                  <div className={styles.itemValue}>
                    {timeLog?.planned_time ? timeLog.planned_time : <TableNA />}
                  </div>
                </div>
              </div>
              <div
                className={classNames(styles.plannedTitle, styles.actualTitle)}
              >
                {__(
                  isFinalSubstageStatus
                    ? 'tasks.flyout.toolbar.performance.result'
                    : 'tasks.flyout.toolbar.performance.forecast'
                )}
              </div>
              <div className={styles.oneRow}>
                <div className={styles.item}>
                  <div className={styles.itemTitle}>
                    {__(
                      isFinalSubstageStatus
                        ? 'tasks.flyout.toolbar.performance.finished'
                        : 'tasks.flyout.toolbar.performance.estimated_finish'
                    )}
                  </div>
                  <div className={styles.itemValueWithDifference}>
                    {isFinalSubstageStatus ? (
                      finishedAtMoment ? (
                        <div
                          className={classNames(
                            styles.itemValue,
                            finishedDateDifferenceDisplayColor
                          )}
                        >
                          {finishedAtMoment.format('DD.MM.YYYY')}
                        </div>
                      ) : (
                        <TableNA />
                      )
                    ) : (
                      <div
                        className={classNames(
                          styles.itemValue,
                          finishedDateDifferenceDisplayColor
                        )}
                      >
                        {moment().format('DD.MM.YYYY')}
                      </div>
                    )}
                    {finishedDateDifferenceLabel && (
                      <div
                        className={classNames(
                          styles.itemValueDifference,
                          finishedDateDifferenceDisplayColor
                        )}
                      >
                        {finishedDateDifferenceLabel}
                      </div>
                    )}
                  </div>
                </div>
                <div className={classNames(styles.item, styles.secondItem)}>
                  <div className={styles.itemTitle}>
                    {__(
                      isFinalSubstageStatus
                        ? 'tasks.flyout.toolbar.performance.actual_time'
                        : 'tasks.flyout.toolbar.performance.estimated_time'
                    )}
                  </div>
                  <div className={styles.itemValueWithDifference}>
                    {hasLoggedTimeValue ? (
                      <div
                        className={classNames(
                          styles.itemValue,
                          actualTimeDifferenceDisplayColor
                        )}
                      >
                        {timeLog?.logged_time}
                      </div>
                    ) : (
                      <TableNA />
                    )}
                    {actualTimeDifferenceLabel && (
                      <div
                        className={classNames(
                          styles.itemValueDifference,
                          actualTimeDifferenceDisplayColor
                        )}
                      >
                        {actualTimeDifferenceLabel}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div
                className={classNames(styles.plannedTitle, styles.actualTitle)}
              >
                {__('substages.flyout.toolbar.performance.realization')}
              </div>

              <div
                className={classNames(
                  styles.flex,
                  styles.percentageBox,
                  styles.realizationBox
                )}
              >
                <div className={styles.realizationRow}>
                  <div className={styles.percentageTitle}>
                    {__('substages.flyout.toolbar.progress')}{' '}
                    {progress_percentage ?? 0}%
                  </div>
                  <div className={styles.slider}>
                    <RangeSlider
                      value={progress_percentage}
                      disabled
                      color={data?.progress_color}
                    />
                  </div>
                </div>
                <div className={styles.realizationRow}>
                  <div className={styles.percentageTitle}>
                    {__('substages.flyout.toolbar.schedule.progress')}{' '}
                    {schedule?.elapsed_percent ?? 0}%
                  </div>
                  <div className={styles.slider}>
                    <RangeSlider
                      value={schedule?.elapsed_percent}
                      disabled
                      color={schedule?.schedule_bar_color}
                    />
                  </div>
                </div>
                <div className={styles.realizationRow}>
                  <div className={styles.percentageTitle}>
                    {__('substages.flyout.toolbar.timelog.progress')}{' '}
                    {timeLog?.logged_percent ?? 0}%
                  </div>
                  <div className={styles.slider}>
                    <RangeSlider
                      value={timeLog?.logged_percent}
                      disabled
                      color={timeLog?.time_log_color}
                    />
                  </div>
                </div>
              </div>
            </div>
          }
        >
          <Tooltip text={__('substages.tooltip.icon.performance')}>
            <div className={styles.timeLogAndSchedulePercentage}>
              {hasPerformanceSummary && (
                <span
                  className={classNames(
                    styles.performanceDot,
                    performanceSummaryColor
                  )}
                />
              )}
              <span
                className={classNames(
                  styles.performanceSummaryLabel,
                  !hasPerformanceSummary && styles.performanceSummaryPlaceholder
                )}
              >
                {performanceSummaryLabel}
              </span>
              <div className={styles.rightCorner}>
                <ArrowDownSmallIcon className={styles.dropdownArrow} />
              </div>
            </div>
          </Tooltip>
        </Dropdown>
      </Form>
    );
  }
}

export default EditSubstageToolbarForm;
